import { useEditorMode } from "./EditorModeContext";

export function EditorToolbar() {
  const { editMode, setEditMode } = useEditorMode();

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <button
        onClick={() => setEditMode("design")}
        style={{
          background: editMode === "design" ? "#1A73E8" : "#fff"
        }}
      >
        Design
      </button>

      <button
        onClick={() => setEditMode("preview")}
        style={{
          background: editMode === "preview" ? "#1A73E8" : "#fff"
        }}
      >
        Preview
      </button>
    </div>
  );
}